import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import FailedView from "../views/FailedView.vue";
import { RouteNames } from "./RouteNames";
import { registerGuard } from "./Guard";
import HomeView from "@/views/HomeView.vue";
import StockView from "../views/StockView.vue";
import OnLoanView from "@/views/OnLoanView.vue";
import MovementsView from "@/views/MovementsView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: RouteNames.HOME,
    component: HomeView,
    meta: {
      requiresAuth: true,
      headline: "Ausgabeautomat",
    },
  },
  {
    path: "/Lagerstand",
    name: RouteNames.STOCK,
    component: StockView,
    meta: {
      requiresAuth: true,
      headline: "Lagerstand",
    },
  },
  {
    path: "/Leihartikel",
    name: RouteNames.ONLOAN,
    component: OnLoanView,
    meta: {
      requiresAuth: true,
      headline: "Leihartikel",
    },
  },
  {
    path: "/Artikelbewegungen",
    name: RouteNames.MOVEMENTS,
    component: MovementsView,
    meta: {
      requiresAuth: true,
      headline: "Artikelbewegungen",
    },
  },
  {
    path: "/failed",
    name: "Failed",
    component: FailedView,
  },
  {
    // Small workaround for MSAL: The redirect back looks like "#/code=0.AR8..."
    // VueRouter does not like that so to prevent useless console errors, we just make it a valid route to home.
    path: "/code=:afterCode(.*)",
    name: "OAuthCodeReturn",
    component: HomeView,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

registerGuard(router);

export default router;
